// extracted by mini-css-extract-plugin
export default {"boxInfoMsg":"CS-z","boxErrorMsg":"DS-z","blockMsg":"ES-z","blockInfoMsg":"FS-z","blockErrorMsg":"GS-z","faqLink":"HS-z"};